import { render, staticRenderFns } from "./ProcessingType.vue?vue&type=template&id=08de479b&"
import script from "./ProcessingType.vue?vue&type=script&lang=js&"
export * from "./ProcessingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports